import { useDarkMode } from "@/hooks/useDarkMode";
import React from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { CiWarning } from "react-icons/ci";
import { PiInfo } from "react-icons/pi";

interface CustomToastProps {
  message: string;
  type?: "error" | "success" | "normal";
  onClose?: () => void;
}

const CustomToast: React.FC<CustomToastProps> = ({
  message,
  type = "normal",
  onClose,
}) => {
  let icon;
  let backgroundColor;

  const isDark = useDarkMode();

  switch (type) {
    case "success":
      backgroundColor = "#10B981"; // Green color for success
      icon = (
        <IoCheckmarkCircleOutline
          size={24}
          color={isDark ? "#6EE7B7" : backgroundColor}
        />
      );
      break;
    case "error":
      backgroundColor = "#F87171"; // Red color for error
      icon = <CiWarning size={24} color={backgroundColor} />;
      break;
    default:
      backgroundColor = "#352FC3"; // Blue color for normal
      icon = <PiInfo size={24} color={isDark ? "#A39FE8" : backgroundColor} />;
      if (isDark) {
        backgroundColor = "#A39FE8";
      }
      break;
  }
  return (
    <div
      style={{
        borderTopColor: backgroundColor,
      }}
      className="bg-primary-50 dark:bg-[#313A71] rounded-[10px] border-t-[8px] flex flex-col"
    >
      <div className="flex-1 py-[12px] flex flex-row">
        <div className="px-[12px]">{icon}</div>
        <div className="flex-1 justify-center pr-[16px]">
          <div className="paragraph-small-medium text-primary-900 dark:text-primary-50">
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomToast;
